<y42-job-status [jobStatus]="state.jobStatus"></y42-job-status>
